(function () {
  angular.module("akitabox.building.list", [
    "akitabox.core.router",
    "akitabox.core.services.building",
  ]);
})();
